import React, { FC, ReactNode } from "react";

type SummaryPartProps = {
  label: string;
  content?: ReactNode;
  additionalContent?: string;
  showJobTitle?: boolean;
};

export const SummaryPart: FC<SummaryPartProps> = ({
  label,
  content,
  additionalContent,
  children,
  showJobTitle,
}) => {
  return (
    <div className="SummaryPart">
      <dt className="SummaryPart__label">{label}: </dt>
      <dd className="SummaryPart__content">
        {content ?? children}
        {showJobTitle && ","}{" "}
        {additionalContent && showJobTitle && <span>{additionalContent}</span>}
      </dd>
    </div>
  );
};
